import { render, staticRenderFns } from "./TestApplicationUpdateList.vue?vue&type=template&id=504ea496"
import script from "./TestApplicationUpdateList.vue?vue&type=script&lang=js"
export * from "./TestApplicationUpdateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports